module.exports = __webpack_public_path__ + "assets/img/jieshao11.37032b5a.svg";